import "bootstrap";
import * as React from "react";
import { render } from "react-dom";
import { Link } from "react-router-dom";
import { default as UIProvider, IUIProviderConfig } from "@vidazoo/ui/lib/components/uiProvider";
import { ThemeManager } from "@vidazoo/ui-framework";
import { Provider as StateProvider } from "mobx-react";
import { Auth0Provider } from "@auth0/auth0-react";
import * as stores from "common/stores";
import * as _ from "lodash";
import Root from "modules/root";
import Auth0Bridge from "modules/auth/Auth0Bridge";

_.templateSettings.interpolate = /([a-zA-Z]+)/g;

const uiProviderConfig: IUIProviderConfig = {
	appContainerSelector: "#root",
	linkComponent: Link,
	baseAppTitle: "vidazoo bi-dashboard",
	warnDevProductionApiUsage: true
};

render(
	<Auth0Provider
		domain={window.authConfig.AUTH0_DOMAIN}
		clientId={window.authConfig.AUTH0_CLIENT_ID}
		authorizationParams={{
			redirect_uri: window.location.origin,
			audience: window.authConfig.AUTH0_AUDIENCE,
			scope: "openid profile email"
		}}
	>
		<UIProvider config={uiProviderConfig}>
			<StateProvider {...stores}>
				<ThemeManager>
					<Auth0Bridge />
					<Root />
				</ThemeManager>
			</StateProvider>
		</UIProvider>
	</Auth0Provider>,
	document.querySelector(uiProviderConfig.appContainerSelector)
);
